import React from 'react';
import CollapsibleHelp from '../../components/CollapsibleHelp';

export default function MarketingPopupBehaviorTab({ config, setConfig }) {
  const set = (patch) => setConfig((c) => ({ ...c, ...patch }));

  return (
    <div className="marketing-popup-behavior">
      <CollapsibleHelp title="Gedrag & preview">
        <p>
          Personaliseert <strong>titel/tekst/knop</strong> op de shop op basis van mandje, productviews en configurator.
          Pas teksten hier aan — rechts in de preview: segment <strong>Scenario</strong> (Mandje / Views / Configurator).
          E-mail-automation via Xendy volgt op tags (sync bij inschrijving).
        </p>
      </CollapsibleHelp>

      <label className="marketing-ig-checkbox mpp-card-toggle">
        <input
          type="checkbox"
          checked={!!config?.behavior_enabled}
          onChange={(e) => set({ behavior_enabled: e.target.checked })}
        />
        Gedragsregels actief
      </label>

      <label className="mpp-behavior-delay">
        Vertaling gedrag-pop-up (sec na trigger)
        <input
          type="number"
          className="form-input"
          min={0}
          max={300}
          value={config?.behavior_delay_seconds ?? 30}
          onChange={(e) => set({ behavior_delay_seconds: Number(e.target.value) })}
        />
      </label>
      <CollapsibleHelp title="Vertaling gedrag-pop-up" className="collapsible-help--compact">
        <p>
          Na configurator, mandje of voldoende views: pop-up pas na dit aantal seconden <strong>sinds die actie</strong>,
          bovenop de algemene delay uit tab Timing.
        </p>
      </CollapsibleHelp>

      <div className="mpp-card-grid">
        <section className="mpp-card">
          <h4 className="mpp-card-title">Verlaten mandje</h4>
          <label className="marketing-ig-checkbox">
            <input
              type="checkbox"
              checked={!!config?.behavior_use_cart_abandon}
              onChange={(e) => set({ behavior_use_cart_abandon: e.target.checked })}
            />
            Gebruik mandje-snapshot (Woo)
          </label>
          <label>
            Max. uren geleden
            <input
              type="number"
              className="form-input"
              min={1}
              max={168}
              value={config?.behavior_cart_abandon_hours ?? 48}
              onChange={(e) => set({ behavior_cart_abandon_hours: Number(e.target.value) })}
            />
          </label>
          <label className="marketing-ig-checkbox">
            <input
              type="checkbox"
              checked={!!config?.behavior_cart_use_returning_code}
              onChange={(e) => set({ behavior_cart_use_returning_code: e.target.checked })}
            />
            Terugkerend + mandje → TERUG-code (als % &gt; 0)
          </label>
          <label>
            Titel
            <input
              className="form-input"
              value={config?.title_behavior_cart || ''}
              onChange={(e) => set({ title_behavior_cart: e.target.value })}
            />
          </label>
          <label>
            Tekst
            <textarea
              className="form-input"
              rows={2}
              value={config?.body_behavior_cart || ''}
              onChange={(e) => set({ body_behavior_cart: e.target.value })}
            />
          </label>
          <label>
            Knop
            <input
              className="form-input"
              value={config?.button_behavior_cart || ''}
              onChange={(e) => set({ button_behavior_cart: e.target.value })}
            />
          </label>
        </section>

        <section className="mpp-card">
          <h4 className="mpp-card-title">Hoge intentie (productviews)</h4>
          <label className="marketing-ig-checkbox">
            <input
              type="checkbox"
              checked={!!config?.behavior_use_high_intent}
              onChange={(e) => set({ behavior_use_high_intent: e.target.checked })}
            />
            Actief
          </label>
          <div className="marketing-popup-grid">
            <label>
              Min. views
              <input
                type="number"
                className="form-input"
                min={2}
                max={20}
                value={config?.behavior_min_product_views ?? 3}
                onChange={(e) => set({ behavior_min_product_views: Number(e.target.value) })}
              />
            </label>
            <label>
              Periode (dagen)
              <input
                type="number"
                className="form-input"
                min={1}
                max={30}
                value={config?.behavior_product_view_days ?? 7}
                onChange={(e) => set({ behavior_product_view_days: Number(e.target.value) })}
              />
            </label>
          </div>
          <label>
            Titel
            <input
              className="form-input"
              value={config?.title_behavior_intent || ''}
              onChange={(e) => set({ title_behavior_intent: e.target.value })}
            />
          </label>
          <label>
            Tekst
            <textarea
              className="form-input"
              rows={2}
              value={config?.body_behavior_intent || ''}
              onChange={(e) => set({ body_behavior_intent: e.target.value })}
            />
          </label>
          <label>
            Knop
            <input
              className="form-input"
              value={config?.button_behavior_intent || ''}
              onChange={(e) => set({ button_behavior_intent: e.target.value })}
            />
          </label>
        </section>

        <section className="mpp-card mpp-card--wide">
          <h4 className="mpp-card-title">Configurator geopend</h4>
          <label className="marketing-ig-checkbox">
            <input
              type="checkbox"
              checked={!!config?.behavior_use_configurator}
              onChange={(e) => set({ behavior_use_configurator: e.target.checked })}
            />
            Actief (prioriteit na mandje)
          </label>
          <label>
            Titel
            <input
              className="form-input"
              value={config?.title_behavior_configurator || ''}
              onChange={(e) => set({ title_behavior_configurator: e.target.value })}
            />
          </label>
          <label>
            Tekst
            <textarea
              className="form-input"
              rows={2}
              value={config?.body_behavior_configurator || ''}
              onChange={(e) => set({ body_behavior_configurator: e.target.value })}
            />
          </label>
          <label>
            Knop
            <input
              className="form-input"
              value={config?.button_behavior_configurator || ''}
              onChange={(e) => set({ button_behavior_configurator: e.target.value })}
            />
          </label>
        </section>
      </div>
    </div>
  );
}
